import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { SDKVersion } from '../models';
import { SDKVersionSearchParam } from '../models/sdk-version-search-param.model';
import { AlloxApiService } from './allox-api.service';

@Injectable({ providedIn: 'root' })
export class SDKVersionService {

  private path = '/sdk_versions';

  constructor(private http: AlloxApiService) { }

  public search(param?: SDKVersionSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new SDKVersion(obj))),
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new SDKVersion(obj))
    );
  }

  public post(item: SDKVersion) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: SDKVersion) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public deletes(items: SDKVersion[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }
}
